module.exports = __webpack_public_path__ + "img/newfranquicia_blanco.dbdf07bb.png";